import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';

export const Container = styled.div`
  flex: 1;

`;

export const Separator = styled.div<{theme: Theme}>`
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.chatSeparator};
  border-bottom-style: solid;
  margin-left: 16px;
  margin-right: 16px;
`;
